<template>
    <div class="custom-filter">
        <div class="custom-filter__inputs align-start">
            <div class="custom-filter__inputs--label">
                Date
                <div class="label currency-datepicker">
                    <div class="label__input-wrap">
                        <datepicker placeholder="De"
                                    format="DD/MM/YYYY"
                                    :monday-first="true"
                                    :full-month-name="true"
                                    wrapper-class="currency-datepicker__wrapper-low-margin mb-3"
                                    input-class="currency-datepicker__input"
                                    calendar-class="currency-datepicker__element"
                                    v-model="filters.start_date"
                                    :highlighted="filters.start_date ? '' : highlightedConfig">
                        </datepicker>
                        <datepicker placeholder="à"
                                    format="DD/MM/YYYY"
                                    :monday-first="true"
                                    :full-month-name="true"
                                    wrapper-class="currency-datepicker__wrapper-low-margin"
                                    input-class="currency-datepicker__input"
                                    calendar-class="currency-datepicker__element"
                                    v-model="filters.end_date"
                                    :highlighted="filters.end_date ? '' : highlightedConfig">
                        </datepicker>
                    </div>
                </div>
            </div>

<!--            <label class="custom-filter__inputs&#45;&#45;label">-->
<!--                Invoice Number-->
<!--                <input class="custom-filter__inputs&#45;&#45;field" v-model="filters.invoice_number">-->
<!--            </label>-->

            <label class="custom-filter__inputs--label">
                Montant
                <input class="custom-filter__inputs--field" v-model="filters.amount"
                       oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');">
            </label>

        </div>
        <div class="custom-filter__buttons">
            <button class="custom-filter__buttons--button" @click="emitFilters">Rechercher</button>
        </div>
    </div>
</template>

<script>
    import Datepicker from '@/components/DatepickerCustom/src/components/Datepicker'

    export default {
        name: 'FacturesCustomFilter',
        components: {Datepicker},
        data() {
            return {
                highlightedConfig: {
                    dates: [new Date()],
                }
            }
        },
        props: {
            filters: Object
        },
        methods: {
            emitFilters() {
                this.$eventBus.$emit('get-factures');
            }
        },
        mounted() {

        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Factures/FacturesCustomFilter.vue